<div class="navigation">
    <div *ngIf="child" class="nav-menu clearfix margin-bottom-0 nav-menu-style-">
        <ul class="layouts level-1">
            <ng-container *ngFor="let menu of child">
                <li *ngIf="!(menu.id === 'marketalerts' || menu.id  === 'sectorindustry'); else modPageCheck"
                    [ngClass]="{'selected': (grandChild === menu.id)}">
                    <a [ngClass]="{'selected': (grandChild === menu.id)}" id="nav-{{menu.id}}"
                        href="javascript:void(0);" (click)="handleThirdLevelNavigation(menu)">
                        {{ menu.name | pershingTranslate}}
                    </a>
                </li>
                <ng-template #modPageCheck>
                    <li [ngClass]="{'selected': (grandChild === menu.id)}"
                        *ngIf="menu.id === 'sectorindustry'; else marketAlertsCheck">
                        <a [ngClass]="{'selected': (grandChild === menu.id)}" id="nav-{{menu.id}}" href="javascript:void(0);"
                            (click)="gotoPageEvent('/nxi/research/markets/sectorindustry/sectorindusperformance')">
                            {{ menu.name | pershingTranslate}}</a>
                    </li>
                </ng-template>
                <ng-template #marketAlertsCheck>
                    <li [ngClass]="{'selected': (grandChild === menu.id)}" *ngIf="alertsSigned; else marketAlertsPopup">
                        <a [ngClass]="{'selected': (grandChild === menu.id)}" id="nav-{{menu.id}}" href="javascript:void(0);"
                            (click)="gotoPageEvent('/nxi/research/investtools/marketalerts/securitiesalerts')">{{ menu.name | pershingTranslate}}</a>
                    </li>
                    <ng-template #marketAlertsPopup>
                        <li [ngClass]="{'selected': (grandChild === menu.id)}">
                            <a
                                href="javascript:F2Container.prototype.callAgreementPage('M', 'data')">{{ menu.name | pershingTranslate}}</a>
                        </li>
                    </ng-template>
                </ng-template>
            </ng-container>
        </ul>
    </div>
</div>